const data = [
  {
    id: 1,
    image: 'https://picsum.photos/50/50?random=1',
    title: 'Diseño responsivo',
    icon: 'fas fa-mobile-alt main',

    description:
      '"🔍 Capacidad para definir estrategias y crear sitios web adaptables a diferentes tipos de dispositivos. 📱💻"',
  },
  {
    id: 2,
    image: 'https://picsum.photos/50/50?random=2',
    icon: 'fas fa-code main',
    title: 'Desarrollo',
    description:
      '"🚀 Desarrollando aplicaciones escalables y sostenibles para resolver problemas con maestría."',
  },
  {
    id: 3,
    image: 'https://picsum.photos/50/50?random=3',
    icon: 'fas fa-globe main',
    title: 'Desarrollador Web y de Software',
    description:
      '💻🚀 Especializado en software y sitios web de alto rendimiento, mi meta es optimizar la experiencia del usuario para tu completa satisfacción.',
  },
  /* {
    id: 4,
    image: 'https://picsum.photos/50/50?random=3',
    icon: 'fas fa-globe main',
    title: 'Mejor Diseño Mejor Experiencia',
    description: 'Muestra diseños innovadores y experiencia de usuario únicos',
  },
  {
    id: 5,
    image: 'https://picsum.photos/50/50?random=3',
    icon: 'fas fa-globe main',
    title: 'Patrones',
    description:
      'Estudio de diseño de patrones para resolución persistentes en el desarrollo web',
  },
  {
    id: 6,
    image: 'https://picsum.photos/50/50?random=3',
    icon: 'fas fa-globe main',
    title: 'Web App',
    description:
      'El uso de nuevas tecnologías para la resolución de problemas en aplicaciones web',
  }, */
];

export default data;
